module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.12454/images/aha-moment/product-tour.svg"